module.exports = __webpack_public_path__ + "static/media/maplocation.73d77431.svg";